import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "clip-box" }
const _hoisted_2 = {
  id: "copyDom",
  class: "copy-number"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.wecity.qq.com/miying/copy-icon-0ec3329b10d716c09c66723f1a46d956.png",
  alt: "",
  class: "copy-btn-icon"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "copy-btn-text" }, "复制", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.copyContent), 1),
    _createElementVNode("div", {
      class: "copy-btn",
      id: "copyBtn",
      "data-clipboard-action": "copy",
      "data-clipboard-target": "#copyDom",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickCopy && _ctx.clickCopy(...args)))
    }, _hoisted_5)
  ]))
}